import { PlatformMark } from '../../PlatformMark';
import { platformMeta } from '../../../lib/catalogPlatform';
import type { CategoryId } from '../../../features/catalog/model';
import { Icon } from '../../Icon';
import { OTHER_HUE, OTHER_ID } from './dailySeries';

export interface BandLogoProps {
  /** the gateway platform id the band is keyed by, e.g. `twitter`, `maps` */
  id: string;
  /** catalog category per catalog card id, which colours an unbranded mark */
  categories: Record<string, CategoryId>;
  /** glyph size in px */
  size?: number;
}

/**
 * A band's platform logo, drawn by the site's one platform-mark rule. The
 * leftover band stands for many platforms, so it draws a grid of squares in
 * its own grey at the same size.
 */
export const BandLogo = ({ id, categories, size = 14 }: BandLogoProps) => {
  if (id === OTHER_ID) {
    return (
      <span
        className="inline-flex shrink-0"
        style={{ width: size, height: size, color: OTHER_HUE }}
      >
        <Icon name="layout-grid" size={size} strokeWidth={2} />
      </span>
    );
  }
  const meta = platformMeta(id);
  return (
    <span className="inline-flex shrink-0 text-text" style={{ width: size, height: size }}>
      <PlatformMark
        id={meta.id}
        icon={meta.icon}
        category={categories[meta.id] ?? 'data'}
        size={size}
        bare
      />
    </span>
  );
};
